import styles from "./Login.module.scss";
import {useTranslation} from "react-i18next";
import {Form} from "antd";
import LoginFormItemInput from "../../../components/UI/LoginFormItemInput/LoginFormItemInput";
import LoginFormItemInputPassword from "../../../components/UI/LoginFormItemInputPassword/LoginFormItemInputPassword";
import {Link, useNavigate} from "react-router-dom";
import CustomButton from "../../../components/UI/CustomButton/CustomButton";
import {ILoginRequest} from "../../../models/Auth";
import {AuthService} from "../../../services/auth.service";
import useAppDispatch from "../../../hooks/useAppDispatch";
import {login, logout} from "../../../store/profile/profileSlice";
import {openMessage} from "../../../store/notification/notificationSlice";
import React, {useState} from "react";
import {IMultiGymInfo, setActiveGym} from "../../../store/multiGyms/multiGymsSlice";
import useAppSelector from "../../../hooks/useAppSelector";
import {$clientApi} from "../../../http";
import LoginGymSelect from "../../../components/UI/LoginGymSelect/LoginGymSelect";

export const Login = () => {

    const {t} = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const {activeGym} = useAppSelector(state => state.multiGymsSlice);

    const [selectedGym, setSelectedGym] = useState<null | IMultiGymInfo>(null);

    const makeLogoutBeforeLogin = () => {
        dispatch(logout());
        AuthService.logout();
    }

    const onFinish = async (values: ILoginRequest) => {
        values.username = values.email;
        makeLogoutBeforeLogin();
        const gymToLogin = selectedGym ? selectedGym : activeGym;
        try {
            const response = await AuthService.login(values, gymToLogin.endpoint);
            if (response.data.length) {
                AuthService.setTokens({access_token: response.data[0].access_token, refresh_token: response.data[0].refresh_token});

                $clientApi.defaults.baseURL = gymToLogin.endpoint;
                const profileResponse = await AuthService.getProfile();
                if (profileResponse.data) {
                    localStorage.setItem("active_gym_info", JSON.stringify(gymToLogin));
                    dispatch(setActiveGym(gymToLogin));

                    dispatch(login(profileResponse.data));
                    dispatch(openMessage({type: "success", title: t("LoggedIntoYourAccount")}));
                    navigate("/");
                } else {
                    $clientApi.defaults.baseURL = activeGym.endpoint;

                    AuthService.logout();
                    dispatch(openMessage({type: "error", title: t("PasswordOrLoginEnteredIncorrectly")}));
                }
            } else {
                dispatch(openMessage({type: "error", title: t("PasswordOrLoginEnteredIncorrectly")}));
            }
        } catch (e: any) {
            if (e.response && e.response.data && e.response.data.message) {
                dispatch(openMessage({type: "error", title: t(e.response.data.message)}));
            } else {
                dispatch(openMessage({type: "error", title: t("PasswordOrLoginEnteredIncorrectly")}));
            }

        }

    }

    const redirectToRegister = () => {
        navigate("/auth/register");
    }

    return (
        <div className={styles.wrapper}>
            <h2 className={styles.title}>{t("Login")}</h2>
            <Form
                className={styles.form}
                name="login"
                onFinish={onFinish}
            >
                <LoginFormItemInput
                    name={"email"}
                    label={t("EmailAddress")}
                    rules={{required: true}}
                />

                <LoginFormItemInputPassword
                    name={"password"}
                    label={t("Password")}
                    rules={{required: true}}
                />

                <LoginGymSelect
                    mode={"dark"}
                    selectedGym={selectedGym}
                    setSelectedGym={setSelectedGym}
                />

                <div className={styles.linkWrapper}>
                    <Link
                        className={styles.link}
                        to={"/auth/forgot-password"}
                    >
                        {t("ForgotYourPassword")}?
                    </Link>
                </div>

                <div className={styles.bottom}>

                    <CustomButton
                        text={t("SignIn")}
                        type={"submit"}
                        typeStyle={"fill"}
                        borderRadius={true}
                    />

                    <div className={styles.divider}>
                        <div className={styles.line}></div>
                        <p className={styles.text}>{t("DontHaveAnAccount")}?</p>
                        <div className={styles.line}></div>
                    </div>

                    <CustomButton
                        text={t("CreateYourAccount")}
                        type={"button"}
                        typeStyle={"outline"}
                        borderRadius={true}
                        functionOnClick={redirectToRegister}
                    />

                </div>

            </Form>
        </div>
    )
}

export default Login;